import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CButton,
	CModal,CModalBody,CModalFooter,CModalHeader,CModalTitle,
	CForm,CFormInput,CListGroup,CListGroupItem,
	CRow,CCol,
	CCard,CCardBody,
	CLink,
	CSpinner,
	CCloseButton,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import PropTypes from 'prop-types';
import { UFunc } from "../helpers/functions";

const pjson 	= require('../../package.json')
const MyDialogperawat = (props) => {
	const {
		showToast,prosesExpired,setSessionaktif,
		show,toggle,dataSelectedArr,onKlikSimpan,
		...rest
	} = props;

	const uDispatch 				= useDispatch();

	//--MUST_THERE--/
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uEfekapp					= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	//--END MUST_THERE--/

	//--LOCALVARS--/
	const uDataselectedArr			= dataSelectedArr || [];
	const [uDataperawatArr,setDataperawatArr]	= React.useState([]);
	const [uDatashowArr,setDatashowArr]			= React.useState([]);//-->perawat_lookup_arr
	const [uDataselectingArr,setDataselectingArr]= React.useState([]);//->perawat_selecting_arr
	const [uInpkeyword,setInpkeyword]			= React.useState("");
	const [uISLoadingkomponen,setLoadingkomponen]	= React.useState(false);
	const [uISExecutesimpan,setExecutesimpan]	= React.useState(false);
	//--END LOCALVARS--/

	//--DOM--/
	const uWindowwidth			= window.outerWidth;
	const uISTabletview			= uWindowwidth > 425 && uWindowwidth <= 768;
	const uISCellphoneview		= uWindowwidth <= 425;
	//--END DOM--*/

	//--HANDEL--/
	const hdlChangePerawatnote = (_EV,_ID) => {
		_ID 			= parseInt(_ID) || 0;
		const vValuenote= (_EV.target.value || "");//.trim();

		const vSelectedidx	= UFunc.getObjectIndeks(uDatashowArr,_ID);
		const vValuestored	= parseInt((uDatashowArr[vSelectedidx]||{}).rate_bintang) || 0;
		const vIDitem		= parseInt((uDatashowArr[vSelectedidx]||{}).id_item) || 0;
		const vNamaperawat 	= (uDatashowArr[vSelectedidx]||{}).nama_perawat || "";
		
		const vArridx		= UFunc.getObjectIndeks(uDataselectingArr,_ID);
		if(vArridx < 0 ) {
			setDataselectingArr([...uDataselectingArr,
				{id:_ID, id_item: vIDitem, nama_perawat: vNamaperawat,rate_bintang: vValuestored, catatan: vValuenote }
			]);
			return;
		}

		const vValuebefore		= parseInt(uDataselectingArr[vArridx].rate_bintang) || 0;
		if(vValuenote.trim() === "" && vValuebefore === vValuestored) {
			uDataselectingArr.splice(vArridx,1);
			setEfekview(!uEfekview);
			return;
		}

		uDataselectingArr[vArridx]= {
			...(uDataselectingArr[vArridx]),
			catatan: vValuenote,
		}
		setEfekview(!uEfekview);
	}
	const hdlKlikPerawatstar = (_VALUE,_ID) => {
		_ID 			= parseInt(_ID) || 0;
		_VALUE 			= parseInt(_VALUE) || 0;

		const vSelectedidx	= UFunc.getObjectIndeks(uDatashowArr,_ID);
		const vValuestored	= parseInt((uDatashowArr[vSelectedidx]||{}).rate_bintang) || 0;
		const vNotestored	= (uDatashowArr[vSelectedidx]||{}).catatan;
		const vIDitem		= parseInt((uDatashowArr[vSelectedidx]||{}).id_item) || 0;

		const vArridx	= UFunc.getObjectIndeks(uDataselectingArr,_ID);
		if(vArridx < 0 ) {
			const vNewselectingval 		= vValuestored === _VALUE ? 0 : _VALUE;
			const vNewselectinghapus 	= vValuestored === _VALUE ? "YA" : undefined;
			setDataselectingArr([
				...uDataselectingArr,
				{
					id:_ID,
					id_item: vIDitem,
					nama_perawat: (uDatashowArr[vSelectedidx]||{}).nama_perawat,
					rate_bintang: vNewselectingval, 
					catatan: vNotestored, 
					status_hapus:vNewselectinghapus 
				}
			])
			return;
		}

		const vValuebefore		= parseInt(uDataselectingArr[vArridx].rate_bintang) || 0;
		if(vValuebefore === _VALUE && vValuestored === _VALUE) {
			uDataselectingArr[vArridx]= {
				...(uDataselectingArr[vArridx]),
				rate_bintang: 0,
				catatan:undefined,
				status_hapus:"YA"
			}
			setEfekview(!uEfekview);
			return;
		}

		if(vValuebefore === _VALUE || vValuestored === _VALUE) {
			uDataselectingArr.splice(vArridx,1);
			setEfekview(!uEfekview);
			return;
		}

		uDataselectingArr[vArridx]= {
			...(uDataselectingArr[vArridx]),
			rate_bintang: _VALUE,
			catatan: vNotestored,
		}
		setEfekview(!uEfekview);
	}
	const hdlKliksimpan = () => {
		//--CEK_RATE_MIN_3_HARUS_PAKE_NOTE--/
		const vPerawatrate3Arr	= uDataselectingArr.
			filter(vItems=>
				parseInt(vItems.rate_bintang||0) > 0 && parseInt(vItems.rate_bintang||0) < 3 && (vItems.catatan||"").trim() === ""
			);

		if(vPerawatrate3Arr.length > 0) {
			const vListperawat = vPerawatrate3Arr.map((vItems)=>{
				return "<li>Perawat <b>"+(vItems.nama_perawat||"").toUpperCase()+"</b> Belum Diberi Catatan..</li>";
			}).join("");
			showToast("<p><b>Rating Dibawah 3 Harus Diberi Catatan</b>:</p>"+
				"<ul class='mx-0 ps-4'>"+vListperawat+"</ul>"+
				"<p>Mohon Diperbaiki !</p>"+
				"");
			return;
		}
		//--END CEK_RATE_MIN_3_HARUS_PAKE_NOTE--/

		//--SET_DISPATCH_DULU--/
		uDispatch({type: "set", perawat_selecting_str: JSON.stringify(uDataselectingArr)});
		//--END SET_DISPATCH_DULU--/

		setExecutesimpan(true);
	}
	//--END HANDEL--/

	//--PROCEDURE--/
	//--END PROCEDURE--/

	//--CONTENT--/
	const contentData = () => {
		if(!show) return "";

		const vPerawatshowArr	= uDatashowArr.
			sort((vItemmin, vItemmax) => vItemmax.sort - vItemmin.sort).
			filter(vItems=> vItems.sort > 0 || 
				(vItems.nama_perawat||"").toUpperCase().includes((uInpkeyword).toUpperCase())
				);

		return (
		<>
		{uDataperawatArr.length <= 0 ? (
			<div align="center">&middot; Data Perawat Tidak Ditemukan &middot;</div>
		) : (
			<CCard>
			<CCardBody className="p-0">
			<div className="d-none">{JSON.stringify(uDataselectingArr)}</div>
			<CForm>
			{(vPerawatshowArr).map((vItems,vKeys)=>{
				const vPerawatselectingArr = uDataselectingArr.filter(
					vItemselect=>parseInt(vItemselect.id) === parseInt(vItems.id));

				let vValuestar 		= parseInt(vItems.rate_bintang)||0;
				let vNoteperawat	= (vItems.catatan || "").trim();

				if(vPerawatselectingArr[0]) {
					vValuestar 		= parseInt((vPerawatselectingArr[0]||{}).rate_bintang)|| 0;
					vNoteperawat	= (vPerawatselectingArr[0]||{}).catatan || "";
				}

				return (
					<div key={vKeys}
						className={"p-2 px-1 px-lg-2"+(vKeys < vPerawatshowArr.length-1 ? " classborderbottom" : "")}>
						<div className="d-flex justify-content-between">
							<div className="px-1 pe-0 pe-md-1" style={{minWidth:150,width:"70%"}}>
								{(vPerawatselectingArr.length <= 0 && vItems.sort <= 0) ? (
									<span>{vItems.nama_perawat}</span>
								) : (
								<>
									{(vItems.sort > 0 && vPerawatselectingArr.length <= 0) ? (
									<b className="text-primary">{vItems.nama_perawat}</b>
									) : (
									<>
									<b className="text-success">{vItems.nama_perawat}</b>
									</>
									)}
								</>
								)}
							</div>
							
							<div className="px-0 px-md-1 text-center">
								<CLink onClick={()=>hdlKlikPerawatstar(1,vItems.id)} className="classcursorpointer">
								<CIcon icon="cilStar" className={"me-lg-1"+(vValuestar>=1 ? " fw-bold text-warning":"")} height={uISCellphoneview ? 18 : 20}/>
								</CLink>

								<CLink onClick={()=>hdlKlikPerawatstar(2,vItems.id)} className="classcursorpointer">
								<CIcon icon="cilStar" className={"me-lg-1"+(vValuestar>=2 ? " fw-bold text-warning":"")} height={uISCellphoneview ? 18 : 20}/>
								</CLink>

								<CLink onClick={()=>hdlKlikPerawatstar(3,vItems.id)} className="classcursorpointer">
								<CIcon icon="cilStar" className={"me-lg-1"+(vValuestar>=3 ? " fw-bold text-warning":"")} height={uISCellphoneview ? 18 : 20}/>
								</CLink>

								<CLink onClick={()=>hdlKlikPerawatstar(4,vItems.id)} className="classcursorpointer">
								<CIcon icon="cilStar" className={"me-lg-1"+(vValuestar>=4 ? " fw-bold text-warning":"")} height={uISCellphoneview ? 18 : 20}/>
								</CLink>

								<CLink onClick={()=>hdlKlikPerawatstar(5,vItems.id)} className="classcursorpointer">
								<CIcon icon="cilStar" className={""+(vValuestar>=5 ? " fw-bold text-warning":"")} height={uISCellphoneview ? 18 : 20}/>
								</CLink>
							</div>
						</div>

						{(vValuestar > 0) && (
							<div className="mt-2 px-1">
							<CFormInput size="sm" maxLength={255}
								readOnly={vValuestar <= 0}
								value={vNoteperawat}
								onChange={(e)=>hdlChangePerawatnote(e,vItems.id)}
								placeholder="--Catatan Untuk Perawat"
								id={"inpperawatnote"+vItems.id}/>
							</div>
						)}
					</div>
				)
			})}
			</CForm>
			</CCardBody>
			</CCard>
		)}
		</>
		)
	}
	//--END CONTENT--/

	//--API--/
	const apiLoadawal = () => {
		setHtml500msg();

		setDataperawatArr([])
		setLoadingkomponen(true);

		/*//--TESTING_FRONTEND--/
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_periksa/ld_masterperawat";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoadingkomponen(false);
			if(output_string.tampil) {
				setDataperawatArr(JSON.parse(output_string.masterperawat||"[]"));
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogperawat - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoadingkomponen(true); prosesExpired(); return;
			}
		})
		.catch((error) =>{
			setLoadingkomponen(false);
			console.log("(MyDialogperawat - apiLoadawal) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	//--END API--/

	React.useEffect(()=>{
		apiLoadawal();

		return () => {
			setDataperawatArr([]);
			uDispatch({type: "set", perawat_selecting_str: undefined});
		}
	},[]);
	React.useEffect(()=>{
		//--PROSES_DATASHOW--/
		if(show) {
			setDatashowArr(uDataperawatArr.
				filter(vItems=>{
					const vArrcabangid = vItems.cabangid_arr || [];

					return vArrcabangid.includes(uTokenObj.user_cabangid);
				}).
				map(vItems => {
				const vArridx = UFunc.getObjectIndeks(uDataselectedArr,vItems.id,"id_perawat");

				if(vArridx >= 0) {					
					vItems.sort 		= 1;
					vItems.rate_bintang = parseInt(uDataselectedArr[vArridx].rate_bintang) || 0;
					vItems.catatan 		= uDataselectedArr[vArridx].catatan || "";
					vItems.id_item 		= parseInt(uDataselectedArr[vArridx].id) || 0;
				} else {
					vItems.sort 		= 0;
					vItems.rate_bintang = undefined;
					vItems.catatan 		= undefined;
					vItems.id_item 		= 0;
				}
				return vItems;
			}));

			//console.log("(MyDialogperawat - [show]) uDataselectedArr",uDataselectedArr);
		}
		//--END PROSES_DATASHOW--/

		return ()=>{
			setInpkeyword("");
			setLoadingkomponen(false);
			setDatashowArr([]);setDataselectingArr([]);
			setExecutesimpan(false);
		}
	},[show]);
	React.useEffect(()=>{
		if(!uISExecutesimpan) return;
		setExecutesimpan(false);

		onKlikSimpan();
	},[uISExecutesimpan]);

	return (
		<CModal alignment="center"
			size={(uISTabletview||uISCellphoneview) ? "xl" : "lg"}
			className="z-2099"
			visible={show} 
			scrollable
			{...rest}>
		<CModalHeader closeButton className="bg-dark text-light" closeButton={false}>
			<CModalTitle>Pilih Perawat</CModalTitle>
			<CCloseButton onClick={toggle}/>
		</CModalHeader>

		<CModalBody className="p-0" style={{height:window.innerHeight - 175}} id="idmodalbody">
		{uISLoadingkomponen ? (
			<div className="p-3 p-lg-5 text-center">
				<CSpinner color="warning"/>
			</div>
		) : (
		<>
			{uHtml500msg ? (
				<div className="p-3">
				<CCard>
				<CCardBody className="p-lg-5">
				{UFunc.renderHTML(uHtml500msg)}

				<div className="classborderbottom my-3"/>
				<CButton size="sm" color="light"
					className="text-success fw-bold border-success"
					onClick={()=>apiLoadawal()}
					id="btnRefresh">
					<CIcon icon="cilReload" className="me-1"/>
					Refresh
				</CButton>
				</CCardBody>
				</CCard>
				</div>
			) : (
			<>
			<div className="sticky-top bg-light p-3 px-lg-5" id="idheaderlookup">
				<CFormInput
					size="sm"
					placeholder="--Masukkan Keyword Perawat"
					autoFocus={true}
					value={uInpkeyword}
					onChange={(e)=>setInpkeyword(e.target.value)}
					id="inpdialoglookup"/>
			</div>

			<div className="p-3" id="idrowscroll">
			{contentData()}
			</div>
			</>
			)}
		</>
		)}
		</CModalBody>

		<CModalFooter>
			<CButton className="px-3" color="dark"
				onClick={()=>hdlKliksimpan()}
				disabled={uHtml500msg || uISLoadingkomponen}
				id="btnPerawatsimpan">
				Simpan
			</CButton>

			<CButton className="px-3" color="light" 
				onClick={toggle}
				id="btnPerawatbatal"> 
			{uBahasaObj.word_batal||"Batal"}
			</CButton>
		</CModalFooter>
		</CModal>
	)//>
}

export default MyDialogperawat;